//@ts-nocheck
const DSAREventType = {
  FREE_TEXT: 1,
  WITH_ATTACHMENT: 2,
  STATUS_CHANGE: 3,
  MONITORING_RESPONSE_ENABLED: 4,
  MONITORING_RESPONSE_DISABLED: 5,
  SOLVE_PENDENCY: 6,
};

export default DSAREventType;
